import { foraDaProva } from '@/features/relatos/podeRelatar';

/**
 * "NOVA VERSÃO DO PORTAL · ATUALIZAR" — a pílula do aplicativo, no navegador (24/10/2026, pedido do pesquisador).
 *
 * O achado: no Chrome dele o portal abriu com o menu ANTIGO e só mostrou o novo depois de Cmd+Shift+R. Duas causas, e as
 * duas ficam consertadas juntas:
 *   1. o service worker servia o `index.html` GUARDADO na navegação (`sw.ts`: agora pede à rede primeiro);
 *   2. quem fica com a aba aberta nunca navega "de verdade" — a troca de tela do React não recarrega nada.
 *
 * Para a segunda: cada build grava `versao.json` (`vite.config.ts`, o mesmo carimbo de `__VERSAO_WEB__`), e a página o
 * confere ao voltar à aba e a cada 5 minutos. Havendo outra, aparece a pílula; e, FORA DA PROVA, a próxima navegação já
 * carrega a versão nova (`deveTrocarNaNavegacao`). DENTRO da prova, nada: nem pílula, nem recarga.
 * No aplicativo isto não roda — lá as telas chegam pelo canal (`AtualizadorDeTelas`).
 */
export const ARQUIVO_DA_VERSAO = '/versao.json';
export const INTERVALO_DA_CONFERENCIA_MS = 5 * 60 * 1000;
/** A versão que a recarga já tentou trazer: se ela não chegou (rede, cache), a navegação não recarrega de novo. */
export const CHAVE_DA_TENTATIVA = 'versao-da-web:tentada';

export function haVersaoNova(publicada: string | null | undefined, minha: string): boolean {
  return !!publicada && !!minha && minha !== 'desconhecida' && publicada !== minha;
}

/** Lê a versão publicada, sem cache. Nulo quando não deu para saber (sem rede, servidor de desenvolvimento, 404). */
export async function lerVersaoPublicada(buscar: typeof fetch = fetch): Promise<string | null> {
  try {
    const r = await buscar(`${ARQUIVO_DA_VERSAO}?t=${Date.now()}`, { cache: 'no-store' });
    if (!r.ok) return null;
    const j = (await r.json()) as { web?: unknown };
    return typeof j?.web === 'string' ? j.web : null;
  } catch {
    return null;
  }
}

/**
 * A troca sozinha: há versão nova, a navegação não SAI nem ENTRA na prova, e a recarga ainda não foi tentada para
 * esta versão (se foi e a página continua velha, fica só a pílula — sem recarregar a cada clique).
 */
export function deveTrocarNaNavegacao(p: { publicada: string | null; minha: string; de: string; para: string; tentada: string | null }): boolean {
  return haVersaoNova(p.publicada, p.minha) && foraDaProva(p.de) && foraDaProva(p.para) && p.tentada !== p.publicada;
}

/** A pílula aparece com versão nova e fora da prova. */
export function deveMostrarPilula(p: { publicada: string | null; minha: string; pathname: string }): boolean {
  return haVersaoNova(p.publicada, p.minha) && foraDaProva(p.pathname);
}
